<div class="wrapper" [class.sidebar-collapsed]="isSidebarCollapsed">
  <!-- SIDEBAR CONTAINER -->
  <nav
    class="sidebar"
    id="sidebar"
    [class.show]="isSidebarOpen"
    [class.sidebar-collapsed]="isSidebarCollapsed"
  >
    <div id="sidebar-container">
      <div class="sidebar-header d-flex align-items-center">
        <img src="assets/images/logo.png" alt="Logo" class="me-2 rounded bg-white p-1"
          style="height: 36px; width: auto; object-fit: contain" />
        <h5 class="mb-0 fw-bold text-truncate" style="font-size: 1.1rem">
          CRM System
        </h5>
        <button
          type="button"
          class="sidebar-toggle-btn ms-auto"
          (click)="toggleSidebar()"
          aria-label="Toggle menu"
        >
          <i class="bi bi-list"></i>
        </button>
      </div>
      <div class="sidebar-search p-3">
        <input type="text" class="form-control form-control-sm" placeholder="Search menu..."
          (input)="onSearchMenu($any($event.target).value)">
      </div>
      <div class="sidebar-menu" #sidebarMenu>
        <div class="sidebar-section-header">Core</div>
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-item">
          <i class="bi bi-speedometer2"></i> Dashboard
        </a>
        <button type="button" class="nav-item w-100 border-0 text-start"
          [class.active]="isMenuActive('/notifications', true)" (click)="openNotifications()">
          <i class="bi bi-bell"></i> Notifications
        </button>
        <a routerLink="/task-manager" routerLinkActive="active" class="nav-item">
          <i class="bi bi-check2-square"></i> Task Manager
        </a>

        <div class="sidebar-section-header">Personnel</div>
        <a *ngIf="hasPermission('companies.view')" routerLink="/company/list" [class.active]="isMenuActive('/company')"
          class="nav-item">
          <i class="bi bi-building"></i> Companies
        </a>
        <a *ngIf="hasPermission('employees.view')" routerLink="/employees" [class.active]="isMenuActive('/employees')"
          class="nav-item">
          <i class="bi bi-people"></i> Employees
        </a>
        <a *ngIf="
            hasAnyPermission([
              'roles.view',
              'roles.create',
              'roles.edit',
              'roles.delete',
            ])
          " routerLink="/roles" [class.active]="isMenuActive(['/roles', '/permissions'])" class="nav-item">
          <i class="bi bi-person-badge"></i>Permissions
        </a>
        <a routerLink="/terms-and-conditions" *ngIf="
            hasAnyPermission([
              'terms-conditions.view',
              'terms-conditions.create',
              'terms-conditions.edit',
              'terms-conditions.delete',
            ])
          " routerLinkActive="active" class="nav-item">
          <i class="bi bi-file-text"></i> Terms & Conditions
        </a>
        <a *ngIf="hasPermission('team_type.view')" routerLink="/team-type" routerLinkActive="active" class="nav-item">
          <i class="bi bi-diagram-3-fill"></i> Team Type
        </a>
        <a *ngIf="hasPermission('team.view')" routerLink="/team" routerLinkActive="active" class="nav-item">
          <i class="bi bi-people-fill"></i> Manage Team
        </a>
        <a *ngIf="hasPermission('department.view')" routerLink="/departments" routerLinkActive="active"
          class="nav-item">
          <i class="bi bi-collection-fill"></i> Departments
        </a>
        <a *ngIf="hasPermission('task.view')" routerLink="/tasks" routerLinkActive="active" class="nav-item">
          <i class="bi bi-list-task"></i> Task Master
        </a>

        <a *ngIf="hasPermission('library.view')" routerLink="/libraries" [class.active]="isMenuActive('/libraries')"
          class="nav-item">
          <i class="bi bi-book-fill"></i> Library
        </a>

        <div class="sidebar-section-header">Business</div>
        <a routerLink="/transportation" routerLinkActive="active" class="nav-item">
          <i class="bi bi-truck-front"></i> Transportation
        </a>
        <a *ngIf="hasPermission('suppliers.view')" routerLink="/suppliers" routerLinkActive="active" class="nav-item">
          <i class="bi bi-truck"></i> Suppliers
        </a>
        <a *ngIf="hasPermission('customers.view')" routerLink="/customers" routerLinkActive="active" class="nav-item">
          <i class="bi bi-person-lines-fill"></i> Customers
        </a>

        <div class="sidebar-section-header">O &amp; M Operation</div>
        <a *ngIf="hasPermission('machine_fleet.view')" routerLink="/machine-fleet" routerLinkActive="active" class="nav-item">
          <i class="bi bi-truck"></i> Machine Fleet
        </a>
        <a *ngIf="hasPermission('oandm_project.view')" routerLink="/oandm" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-item">
          <i class="bi bi-tools"></i> Process Sheet
        </a>

        <div class="sidebar-section-header">Purchase Management</div>
        <a *ngIf="
            hasAnyPermission([
              'purchase_indent.view',
              'purchase_indent.create',
              'purchase_indent.edit',
              'purchase_indent.delete',
            ])
          " routerLink="/inventory/purchase-indent/list" [class.active]="isMenuActive('/inventory/purchase-indent')"
          class="nav-item">
          <i class="bi bi-journal-text"></i> Purchase Indent
        </a>
        <a *ngIf="hasAnyPermission([
              'purchase_orders.view',
              'purchase_orders.create',
              'purchase_orders.edit',
              'purchase_orders.delete',])" routerLink="/inventory/purchase-order"
          [class.active]="isMenuActive('/inventory/purchase-order')" class="nav-item">
          <i class="bi bi-cart-check"></i> Purchase Order
        </a>
        <a *ngIf="hasPermission('purchase_indent.view')" routerLink="/inventory/in-house-manufacturing"
          routerLinkActive="active" class="nav-item">
          <i class="bi bi-tools"></i> In House Manufacturing
        </a>
        <a *ngIf="hasPermission('purchase_indent.view')" routerLink="/inventory/job-cards"
          routerLinkActive="active" class="nav-item">
          <i class="bi bi-card-list"></i> Job Cards
        </a>

        <div class="sidebar-section-header">Vouchers</div>
        <a *ngIf="hasPermission('inword.view')" routerLink="/inventory/invert-vouchar/list"
          [class.active]="isMenuActive('/inventory/invert-vouchar')" class="nav-item">
          <i class="bi bi-receipt"></i> Inword
        </a>
        <a *ngIf="hasPermission('outword.view')" routerLink="/inventory/outword-vouchar/list"
          [class.active]="isMenuActive('/inventory/outword-vouchar')" class="nav-item">
          <i class="bi bi-box-arrow-up-right"></i> Outword
        </a>
        <a routerLink="/ledgers" [class.active]="isMenuActive('/ledgers')" class="nav-item">
          <i class="bi bi-journal-bookmark"></i> Ledgers
        </a>

        <div class="sidebar-section-header">Production Management</div>

        <a routerLink="/sub-assembly-master" routerLinkActive="active" class="nav-item" *ngIf="hasPermission('assembly.view')">
          <i class="bi bi-boxes"></i> Sub Assembly
        </a>

        <a  *ngIf="hasPermission('assembly.view')" routerLink="/main-assembly-master" routerLinkActive="active" class="nav-item">
          <i class="bi bi-box-seam"></i> Main Assembly
        </a>

        <a *ngIf="hasPermission('assembly.view')" routerLink="/machine-assembly-master" routerLinkActive="active" class="nav-item">
          <i class="bi bi-gear-wide-connected"></i> Machine Assembly
        </a>

        <a routerLink="/qc-master" routerLinkActive="active" class="nav-item">
          <i class="bi bi-clipboard2-check"></i> QC Checklist Master
        </a>

        <a *ngIf="hasPermission('leads.view')" routerLink="/leads/list" [class.active]="isMenuActive('/leads')"
          class="nav-item">
          <i class="bi bi-person-lines-fill"></i> Leads
        </a>

        <a *ngIf="
            hasAnyPermission([
              'quotations.view',
              'quotations.create',
              'quotations.edit',
              'quotations.delete',
            ])
          " routerLink="/quotations/list" [class.active]="isMenuActive('/quotations')" class="nav-item">
          <i class="bi bi-file-earmark-text"></i> Quotations
        </a>
        <a *ngIf="hasPermission('production_orders.view')" routerLink="/production/orders/list"
          [class.active]="isMenuActive(['/production/orders', '/production-order'])" class="nav-item">
          <i class="bi bi-box-seam"></i> Production Orders
        </a>

        <a *ngIf="hasPermission('production_orders.view')" routerLink="/production/stock-demand"
          routerLinkActive="active" class="nav-item">
          <i class="bi bi-box-arrow-in-down"></i> Stock Demand
        </a>

        <a *ngIf="hasPermission('custome_charges.view')" routerLink="/custome-charges" routerLinkActive="active"
          class="nav-item">
          <i class="bi bi-cash-stack"></i> Custome Charges
        </a>

        <div class="sidebar-section-header">Inventory Management</div>
        <a *ngIf="hasPermission('parts.view')" routerLink="/inventory/parts-list"
          [class.active]="isMenuActive(['/inventory/parts-list', '/inventory/parts-add'])" class="nav-item">
          <i class="bi bi-gear"></i> Parts list
        </a>
        <a routerLink="/inventory/bom-list"
          [class.active]="isMenuActive(['/inventory/bom-list', '/inventory/bom-add', '/inventory/bom-edit'])"
          class="nav-item">
          <i class="bi bi-list-check"></i> BOM
        </a>
        <a *ngIf="hasPermission('model.view')" routerLink="/inventory/model-list"
          [class.active]="isMenuActive(['/inventory/model-list', '/inventory/model-add', '/inventory/model-edit'])"
          class="nav-item">
          <i class="bi bi-boxes"></i> Models
        </a>
        <a *ngIf="hasPermission('stores.view')" routerLink="/inventory/stores" routerLinkActive="active"
          class="nav-item">
          <i class="bi bi-shop"></i> Stores Master
        </a>
        <a *ngIf="hasPermission('brands.view')" routerLink="/inventory/brands" routerLinkActive="active"
          class="nav-item">
          <i class="bi bi-tags"></i> Brands
        </a>
        <a *ngIf="hasPermission('categories.view')" routerLink="/inventory/categories" routerLinkActive="active"
          class="nav-item">
          <i class="bi bi-grid"></i> Categories
        </a>
      </div>
    </div>
  </nav>

  <button
    type="button"
    class="sidebar-backdrop"
    [class.is-visible]="isSidebarOpen"
    (click)="closeMobileSidebar()"
    aria-label="Close navigation menu"
  ></button>

  <div class="main-panel">
    <app-header (sidebarToggle)="toggleSidebar()"></app-header>
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
